import experimentsMCOM from './experimentsMCOM';
import experimentsBCOM from './experimentsBCOM';

export default process.env.ENTRY_POINT === 'mcom' ? experimentsMCOM : experimentsBCOM;
